import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Grid, Paper, TextField } from "@material-ui/core";
import ChequeContractStepSide from "./ChequeContractStepSide";
import ChequeContractStepList from "./ChequeContractStepList";
import FieldDatePicker from "../../Form/FieldDatePicker";

const ChequeContractStep1 = (props) => {
  const tableRef = React.useRef();
  const [saghf, setSaghf] = React.useState(null);

  const triggerSearch = () => {
    if (tableRef.current) tableRef.current.onQueryChange();
  };

  return (
    <Wrapper>
      <Grid container>
        <Grid item xs={12} md={9}>
          <ChequeContractStepList
            tableRef={tableRef}
            setFirstCheque={props.setFirstCheque}
            firstCheque={props.firstCheque}
            percent={props.percent}
            setPercent={(val) => {
              props.setPercent(val);
              triggerSearch();
            }}
            saghf={saghf}
            originDate={props.originDate}
            setOriginDate={props.setOriginDate}
            step={props.step}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Box mb={2}>
            <Paper>
              <Box p={2}>
                <Box mb={2}>
                  <TextField
                    variant={"outlined"}
                    label={"سقف مبلغ"}
                    size={"small"}
                    fullWidth={true}
                    value={
                      saghf
                        ? parseInt(
                            saghf.toString().replaceAll(",", ""),
                          ).format()
                        : ""
                    }
                    onChange={(e) => {
                      const val = e.target.value.replaceAll(",", "");
                      setSaghf(val);
                      triggerSearch();
                    }}
                  />
                </Box>
                <Box mb={2}>
                  <TextField
                    variant={"outlined"}
                    label={"درصد"}
                    size={"small"}
                    fullWidth={true}
                    value={props.percent}
                    onChange={(e) => {
                      props.setPercent(e.target.value);
                      triggerSearch();
                    }}
                  />
                </Box>
                <Box>
                  <FieldDatePicker
                    label={"تاریخ مبدا"}
                    fieldName={"origin_date"}
                    values={{ origin_date: props.originDate }}
                    touched={{ origin_date: false }}
                    setFieldValue={(fieldName, value) => {
                      props.setOriginDate(value);
                      triggerSearch();
                    }}
                  />
                </Box>
              </Box>
            </Paper>
          </Box>
          <ChequeContractStepSide
            firstCheque={props.firstCheque}
            setFirstCheque={props.setFirstCheque}
            percent={props.percent}
            setStep={props.setStep}
            step={props.step}
            originDate={props.originDate}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ChequeContractStep1;
